interface StatusBadgeProps {
  expiresInDays: number
  isExpired: boolean
}

export function StatusBadge({ expiresInDays, isExpired }: StatusBadgeProps) {
  let className = 'status-badge '
  let text = ''

  if (isExpired) {
    className += 'expired'
    text = 'Expired'
  } else if (expiresInDays <= 7) {
    className += 'critical'
    text = `${expiresInDays}d left`
  } else if (expiresInDays <= 30) {
    className += 'warning'
    text = `${expiresInDays}d left`
  } else {
    className += 'healthy'
    text = `${expiresInDays}d left`
  }

  return <span className={className}>{text}</span>
}

interface CredentialTypeBadgeProps {
  type: string
}

export function CredentialTypeBadge({ type }: CredentialTypeBadgeProps) {
  const colors: Record<string, { bg: string; text: string }> = {
    Certificate: { bg: '#e3f2fd', text: '#1565c0' },
    ClientSecret: { bg: '#fff3e0', text: '#ef6c00' },
    FederatedCredential: { bg: '#f3e5f5', text: '#7b1fa2' },
  }

  const style = colors[type] || { bg: '#f5f5f5', text: '#616161' }

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 500,
        backgroundColor: style.bg,
        color: style.text,
      }}
    >
      {type === 'ClientSecret' ? 'Secret' : type === 'FederatedCredential' ? 'Federated' : type}
    </span>
  )
}

interface RiskBadgeProps {
  name: string
  color: string
}

export function RiskBadge({ name, color }: RiskBadgeProps) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 500,
        backgroundColor: `${color}20`,
        color: color,
      }}
    >
      <span
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: color,
        }}
      />
      {name}
    </span>
  )
}
